import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faBehance,
	faGithub,
	faLinkedin,
	faPinterest,
	faTwitter,
	faFacebook,
  faQuora,
} from "@fortawesome/free-brands-svg-icons";

const SocialFollow = () => {
  return (
    <div class="social-container">
      <a href="https://www.behance.net/felixudeine"
        className="behance__social">
        <FontAwesomeIcon icon={faBehance} size="2x" />
      </a>
      <a href="https://github.com/Quekaey"
        className="github__social">
        <FontAwesomeIcon icon={faGithub} size="2x" />
      </a>
      <a href="https://www.linkedin.com/in/felix-tobechukwu-u-821768206/" className="linkedin__social">
        <FontAwesomeIcon icon={faLinkedin} size="2x" />
      </a>
      <a href="https://www.pinterest.com/QueKaey/"
        className="pinterest__social">
        <FontAwesomeIcon icon={faPinterest} size="2x" />
      </a>
      <a href="https://twitter.com/FdPaulusic"
        className="twitter__social">
        <FontAwesomeIcon icon={faTwitter} size="2x" />
      </a>
      <a href="https://web.facebook.com/felix.udeine"
        className="facebook__social">
        <FontAwesomeIcon icon={faFacebook} size="2x" />
      </a>
      <a href="https://www.quora.com/profile/Que-Kaey"
        className="quora__social">
        <FontAwesomeIcon icon={faQuora} size="2x" />
      </a>
    </div> 
  );

}


export default SocialFollow